/**Obsahuje infromace o zašifrovaných objektech*/
export interface IEncryptedInfo {
    /**Kolekce zašifrovaných objektů*/
    encObjsList: IEncryptedObjectDTO[];

    /**Certifikát použitý k šifrování*/
    certificate: string;

    /**
     * Název algoritmu dle specifikace JWK.
     * http://www.w3.org/TR/WebCryptoAPI/#jwk-mapping-alg
     * https://tools.ietf.org/html/rfc7518#appendix-A.2
     */
    algorithmName: string;
}

/**Obsahuje informace o zašifrovaném objektu.*/
export interface IEncryptedObjectDTO {
    /**
     *Id objektu
     */
    instanceID: string;

    /***Symetrický klíč k (de)šifrování objektu, který byl pro přenos od klienta zašifrován asymetrickým klíčem (Base64).*/
    encryptedKey: string;

}
